export default __webpack_public_path__ + "static/media/8-sgi-documentos-v1.bbb6c4c6.png";